import * as React from 'react';

interface SitemapContainerProps {
    title: string;
    children?: JSX.Element | React.ReactNode;
}

const SitemapContainer = (props: SitemapContainerProps) => {
    const { title, children } = props;

    return (
        <div className="min-w-[175pt] flex flex-col justify-start items-start flex-grow gap-4 p-8 border border-[#b4b4b4]/[0.35]">
            <div className="flex flex-col justify-start items-start self-stretch relative gap-2">
                <h2 className="self-stretch text-xl text-left font-semibold text-[#110b29]">{title}</h2>
            </div>
            <div className="flex flex-col justify-start items-start self-stretch gap-4">
                <>{children}</>
            </div>
        </div>
    );
};

export default SitemapContainer;
